import { useQuery } from "@tanstack/react-query";
import { engineError } from "@/lib/engine-error";
import type { ClientPartnerEnvelope } from "@/lib/profitability-api";

/**
 * Profitability grouped by the Client Partner carrying the account.
 *
 * No paging: there are eight rows including Unassigned, and a book-level view
 * that paged would be a strange thing. The range is part of the key for the
 * same reason it is everywhere else here -- switching from 2026 to last-12
 * must not serve the previous range's rows under the new label.
 */
export function useClientPartners(range?: string) {
  return useQuery({
    queryKey: ["client-partners", range ?? "default"],
    queryFn: async (): Promise<ClientPartnerEnvelope> => {
      const params = new URLSearchParams();
      if (range) params.set("range", range);
      const qs = params.toString();
      const response = await fetch(`/api/client-partners${qs ? `?${qs}` : ""}`);
      if (!response.ok) {
        throw await engineError(response, "Could not load client partners");
      }
      return response.json();
    },
    staleTime: 5 * 60 * 1000,
  });
}
